import createEmotion from 'create-emotion';

export const emotionInstance = createEmotion({ key: 'ui-kit-css' });
